import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {RecentFormWidgetPlaceholder} from "./placeholders/recent-form-widget.placeholder";

const RecentFormWidgetAsyncComponent = AsyncComponent(async () => import('./recent-form-widget' /* webpackChunkName: "recent-form-widget" */ ));

export const RecentFormWidgetAsync = (props) => {
  return <React.Suspense fallback={<RecentFormWidgetPlaceholder {...props}/>}>
    <RecentFormWidgetAsyncComponent {...props}/>
  </React.Suspense>
}
